// 默认配置
export default {
  type: 'log', // 表单类型: log - 登录(默认), reg - 注册
  single: false, // 是否相互切换登录/注册表单
  tip: '', // 提示内容
  done: null, // 成功后自定义回调
  forward: '', // 成功后页面会自动跳转到指定位置
  gameId: null
}
